import { Organization } from 'scenes/Dashboard/data/organizations/types'

import {
  ADD_ORGANIZATION_MODAL_STORE_ID,
  AddOrganizationModalState,
} from '../components/AddOrganizationModal/duck/types'

export type OrganizationsManagerState = {
  readonly currentOrganizationId: number | null | undefined
  readonly currentPage: number
  readonly limit: number
  readonly search: string
  readonly organizationsBeingAnalyzed: Organization['id'][]
  readonly deletePopup: OrganizationsManagerDeletePopupState
  readonly components: {
    readonly [ADD_ORGANIZATION_MODAL_STORE_ID]: AddOrganizationModalState
  }
}

export type OrganizationsManagerDeletePopupState = {
  readonly open: boolean
  readonly organizationId: Organization['id'] | null
}

export const ORGANIZATIONS_MANAGER_STORE_ID = 'OrganizationsManager'

export enum PredefinedMatchingFilter {
  filteredZombies = 'FILTERED_ZOMBIES',
}

export enum MatchFilter {
  allActives = 'ALL_ACTIVES',
  allZombies = 'ALL_ZOMBIES',
  filteredZombies = 'FILTERED_ZOMBIES',
}
